export default __webpack_public_path__ + "static/media/github-logo.e0df113a.svg";